import { OPERATIONAL_STATUS } from "../constants";

export const EMPTY = "—";

const MS_PER_MINUTE = 60000;

export function formatDuration(ms) {
  if (ms === null || ms === undefined || !Number.isFinite(ms) || ms < 0) {
    return EMPTY;
  }

  const totalSeconds = Math.round(ms / 1000);

  if (totalSeconds < 60) return `${totalSeconds}s`;

  const minutes = Math.floor(totalSeconds / 60);

  if (ms < 10 * MS_PER_MINUTE) {
    return `${minutes}m ${String(totalSeconds % 60).padStart(2, "0")}s`;
  }

  return `${Math.round(ms / MS_PER_MINUTE)} min`;
}

export function formatAssignment({ currentPlate, currentStatus }) {
  if (!currentStatus) return null;

  const label = OPERATIONAL_STATUS[currentStatus] || currentStatus;

  return currentPlate ? `${currentPlate} ${label.toLowerCase()}` : label;
}

export function porterName(runner) {
  return runner.name || "Unnamed porter";
}

export function totalJobs(runner) {
  return runner.parked + runner.retrieved;
}
